import { render, staticRenderFns } from "./TireWinter.vue?vue&type=template&id=2429bd26&scoped=true&"
var script = {}
import style0 from "./TireWinter.vue?vue&type=style&index=0&id=2429bd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2429bd26",
  null
  
)

export default component.exports